import {merge} from 'ramda';

export const CANCEL_POLICIES = {
  nr:{
    full: '_%esta reserva es no reembolsable, por lo tanto no se puede cancelar o modificar. Para poder hacer la reserva es necesaria una tarjeta de crédito. Una vez hecha la reserva el hotel cargará la cantidad correspondiente en dicha tarjeta.%_',
    short: '_%no reembolsable. Se cobrará el importe al confirmar la reserva.%_',
    showShort: true
  },

  nr_chargeback_usa:{
    full: '_%esta reserva es no reembolsable, por lo tanto no se puede cancelar o modificar. Para poder hacer la reserva es necesaria una tarjeta de crédito.%_',
    short: '_%no reembolsable. Se cobrará el importe al confirmar la reserva.%_',
    showShort: true
  },

  ref_percentage:{
    full: '_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
    short: '_%cancelación gratuita hasta {anticipation} {time_unit} antes de la llegada.%_',
    showShort: true
  },

  ref_days:{
    full: '_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    short: '_%cancelación gratuita hasta {anticipation} {time_unit} antes de la llegada.%_',
    showShort: true
  },

  // Mantenemos estas traducciones comentadas mientras siga revertida la tarea #20291
  ref_percentage_group:{
    //'_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
    full: '_%cancelación gratuita hasta las {hours} del {date}, si cancelas más tarde o en caso de no show el hotel podrá factura el {value}% de la reserva.%_',
    short: '_%cancelación gratuita hasta las {hours} del {date}.%_',
    showShort: true
  },

  ref_days_group:{
    //'_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    full: '_%cancelación gratuita hasta las {hours} del {date}, si cancelas más tarde o en caso de no show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    short: '_%cancelación gratuita hasta las {hours} del {date}.%_',
    showShort: true
  },

  ref_percentage_same_day:{
    full: '_%cancelación gratuita hasta las {hours} del día del check-in, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
    short: '_%cancelación gratuita hasta el día del check-in.%_',
    showShort: true
  },
  ref_days_same_day:{
    full: '_%cancelación gratuita hasta las {hours} del día del check-in, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    short: '_%cancelación gratuita hasta el día del check-in.%_',
    showShort: true
  },

  ref_percentage_same_day_other_date:{
    full: '_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
    short: '_%cancelación gratuita hasta las {hours} del {date}.%_',
    showShort: true
  },
  ref_days_same_day_other_date:{
    full: '_%cancelación sin penalización hasta las {hours} del {date}, después de este periodo o caso de no-show el hotel podrá facturar {nights} {nights_text} de la reserva.%_',
    short: '_%cancelación gratuita hasta las {hours} del {date}.%_',
    showShort: true
  },

  past_release_ref_percentage:{
    full: '_%en caso de cancelación o de no show el hotel facturará un {value}% de la reserva en concepto de gastos.%_',
    short: '_%penalización del {value}% en caso de cancelación o no-show.%_',
    showShort: true
  },
  past_release_ref_days:{
    full: '_%en caso de cancelación o de no show el hotel facturará {nights} {nights_text} en concepto de gastos.%_',
    short: '_%penalización de {nights} {nights_text} por cancelación o no-show.%_',
    showShort: true
  },
  refundable_penalty_checkin_percentage:{
    full: '_%cancelación sin penalización hasta las {time} horas del día de checkin, después de este periodo o caso de no-show el hotel podrá facturar el {value}% de la reserva.%_',
    short: '_%cancelación gratuita hasta las {time} del día del check-in.%_',
    showShort: true
  },

  flexible_rate:{
    full: '_%tarifa flexible con cambio de fechas permitido. Garantiza tu reserva con el pago ahora y si lo deseas, podrás modificar tu fecha de llegada hasta {daysBefore} días antes. Esta reserva es no reembolsable.%_',
    short: '_%tarifa flexible con cambio de fechas hasta {daysBefore} días antes.%_',
    showShort: true
  },
  refundable_free:{
    full: '_%cancelación gratis! Puedes cancelar gratis en cualquier momento.%_',
    short: '_%cancelación gratuita en cualquier momento.%_',
    showShort: true
  }

};


export const CANCEL_POLICIES_MYFLEXROON = {
  nr:{
    full:  '_%consulta los motivos de anulación que garantizan la devolución del importe prepagado. Ver más detalles en las condiciones de tarifa.%_',
    short: '_%consulta los motivos de anulación con reembolso.%_',
    showShort: true
  },

  nr_chargeback_usa:{
    full:  '_%consulta los motivos de anulación que garantizan la devolución del importe prepagado. Ver más detalles en las condiciones de tarifa.%_',
    short: '_%consulta los motivos de anulación con reembolso.%_',
    showShort: true
  }
};

export const GET_TEXT_CANCEL_POLICIES = (pms) => {
  switch (pms) {
    case 'FlexMyRoom':
      return merge(CANCEL_POLICIES, CANCEL_POLICIES_MYFLEXROON);

    default:
      return CANCEL_POLICIES;
  }
};


export const TIME_UNITS = {
  hours: '_%horas%_',
  days: '_%días%_',
  weeks: '_%semanas%_'
};
